import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';

import { buscarProductosConfiguracion } from '../../../actions/configuracion';
import { editarBreadcrumb } from '../../../actions/breadcrumb';
import { formatNumber } from '../../../utils/generalFunctions';

import EliminarProducto from './EliminarProducto';

const tiposProducto = [
    { value: 0, label: 'Alimentos' },
    { value: 1, label: 'Bebidas' },
    { value: 2, label: 'Extras' }
];

const Productos = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { listado } = useSelector(state => state.configuracion.productos);
    const { usuario } = useSelector(state => state.auth);

    const [productoEliminar, setProductoEliminar] = useState(null);

    useEffect(() => {
        dispatch(buscarProductosConfiguracion());
        dispatch(editarBreadcrumb([
            { nombre: 'Configuración', path: '/configuracion/productos', activo: false },
            { nombre: 'Productos', path: '/configuracion/productos', activo: true }
        ]));
    }, []);

    const handleEliminar = (producto) => {
        setProductoEliminar(producto);
    };

    const handleCerrarEliminar = () => {
        setProductoEliminar(null);
    };

    const columns = [
        {
            name: 'Nombre',
            sortable: true,
            selector: row => row.nombre || '-',
            grow: 2
        },
        {
            name: 'Descripción',
            sortable: true,
            selector: row => row.descripcion || '-',
            grow: 2
        },
        {
            name: 'Tipo',
            sortable: true,
            selector: row => tiposProducto.find(t => t.value === row.tipo)?.label || '-'
        },
        {
            name: 'Código',
            sortable: true,
            selector: row => row.codigo || '-'
        },
        {
            name: 'Precio',
            sortable: true,
            selector: row => row.precio != null ? formatNumber(row.precio, 2, '$', '') : '-'
        },
        {
            name: 'Catálogo de precios',
            sortable: true,
            selector: row => row.precios?.length ? 'Si' : 'No'
        },
        {
            name: '',
            cell: row => (
                <div>
                    {usuario?.permisos?.configuracion?.productos?.editar && (
                        <button
                            className="btn btn-sm btn-warning me-1"
                            title="Editar"
                            onClick={() => navigate(`/configuracion/productos/editar/${row._id}`)}
                        >
                            <i className="fas fa-edit"></i>
                        </button>
                    )}
                    {usuario?.permisos?.configuracion?.productos?.eliminar && (
                        <button
                            className="btn btn-sm btn-danger"
                            title="Eliminar"
                            onClick={() => handleEliminar(row)}
                        >
                            <i className="fas fa-trash"></i>
                        </button>
                    )}
                </div>
            )
        }
    ];

    return (
        <div className="row mt-5">
            <div className="col-12 mb-3 d-flex justify-content-between align-items-center">
                <h4 className="mb-4">Productos</h4>
                {usuario?.permisos?.configuracion?.productos?.agregar && (
                    <button className="btn btn-primary" onClick={() => navigate('/configuracion/productos/nuevo')}>
                        <i className="fas fa-plus me-1"></i> Nuevo producto
                    </button>
                )}
            </div>

            <div className="col-12">
                <DataTable
                    columns={columns}
                    data={listado}
                    pagination
                    paginationPerPage={20}
                    paginationComponentOptions={{ rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' }}
                    highlightOnHover
                    noDataComponent="No hay productos registrados"
                />
            </div>

            <EliminarProducto
                producto={productoEliminar}
                handleCerrar={handleCerrarEliminar}
            />
        </div>
    );
};

export default Productos;
